var _style, _desc, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStratisLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 325",
    style: {
      enableBackground: "new 0 0 375 325"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Fill-1_1_);}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-1_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.6355,
    y1: 13.4847,
    x2: 16.4288,
    y2: 309.8508,
    gradientTransform: "matrix(1 0 0 -1 0 326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffffff"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M18.2,110.7l168.7,94.4c0.1,0.1,0.3,0.1,0.4,0L356,110.7c0.2-0.1,0.2-0.4,0-0.6L187.2,15.7 c-0.1-0.1-0.3-0.1-0.4,0L18.2,110.1C18,110.3,18,110.6,18.2,110.7 M180.6,322.8L1.9,222.7c-0.2-0.1-0.2-0.3-0.1-0.5l7.7-12 c0.1-0.2,0.3-0.2,0.5-0.1l176.9,99c0.1,0.1,0.3,0.1,0.4,0L353,216.4c4.1-2.3,6.1-6.9,6.1-11.6v-25.2c0-0.3-0.3-0.4-0.5-0.3 l-165.1,92.5c-4.6,2.5-8.1,2.6-12.8,0l-167-93.5C5.1,172.9,0,163.5,0,153.4v-44c0-6.4,3.3-8.4,8.1-11.1L180.4,1.8 c4.2-2.4,9.1-2.4,13.3,0l174.9,97.9c3.6,2,5.5,6.3,5.5,10.6c0,4-2.3,8.6-5.5,10.4l-175.3,98.2c-4.5,2.5-8.2,2.5-12.6,0L15.4,126.3 c-0.2-0.1-0.5,0-0.5,0.3v26.8c0,5,2.5,9.6,6.8,12.3l165.2,92.5c0.1,0.1,0.3,0.1,0.4,0l168.3-94.3c4.4-2.8,10.6-2.9,14.6,0.7 c2.6,2.3,4,5.7,4,9.1v31c0,9.6-5.5,20-13.2,24.3l-167.6,93.8C188.8,325.4,185.3,325.4,180.6,322.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStratisLogoWhite);
export default __webpack_public_path__ + "static/media/stratis_logo_white.33e91e27909f49ff6996d133c41250c4.svg";
export { ForwardRef as ReactComponent };